import { render, staticRenderFns } from "./contain-img.vue?vue&type=template&id=d1ac894e&scoped=true&"
import script from "./contain-img.vue?vue&type=script&lang=ts&"
export * from "./contain-img.vue?vue&type=script&lang=ts&"
import style0 from "./contain-img.vue?vue&type=style&index=0&id=d1ac894e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ac894e",
  null
  
)

export default component.exports